import React from 'react'

const APIFailureImage = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="240" height="201" fill="none" viewBox="0 0 240 201">
      <path
        fill="url(#paint0_linear_10_830)"
        d="M229.763 115.692A114.88 114.88 0 00114.882.81 114.882 114.882 0 000 115.692h229.763z"
        opacity="0.6"
      />
      <path fill="url(#paint1_linear_10_830)" d="M84.445 41.98h61.805v87.152H84.445V41.98z" />
      <path
        fill="url(#paint2_linear_10_830)"
        d="M104.675 65.938l-20.23 17.673v45.521l42.708-23.992-17.233-4.927-5.459-5.57V84.361l.214-18.423z"
      />
      <path
        fill="#F3F3F3"
        d="M103.79 71.6v-5.301c0-.2.161-.361.36-.361h22.395a.36.36 0 01.36.361v5.3c0 .113.053.219.142.287l6.215 4.773a.36.36 0 01.141.287v16.415a.36.36 0 01-.147.29l-6.203 4.562a.36.36 0 00-.148.291v5.614a.36.36 0 01-.36.362H104.15a.36.36 0 01-.36-.362v-5.614a.363.363 0 00-.147-.29l-6.204-4.562a.361.361 0 01-.147-.291V76.946c0-.112.052-.218.141-.287l6.216-4.773a.361.361 0 00.141-.287z"
      />
      <path
        fill="url(#paint3_linear_10_830)"
        d="M132.871 107.289a3.403 3.403 0 014.076-2.559l7.503 1.716a3.403 3.403 0 01-1.517 6.635l-7.503-1.715a3.404 3.404 0 01-2.559-4.077z"
      />
      <path
        fill="url(#paint4_linear_10_830)"
        d="M129.245 122.005a3.403 3.403 0 014.076-2.559l7.503 1.716a3.403 3.403 0 01-1.517 6.635l-7.503-1.715a3.404 3.404 0 01-2.559-4.077z"
      />
      <path
        fill="#818C9E"
        d="M142.431 125.119l-12.847-3.279 2.089 4.304 9.087 1.946 1.671-2.971zM146.25 110.136l-13.194-3.226 2.145 4.234 9.333 2.016 1.716-3.024z"
      />
      <path
        fill="#ADB2BE"
        d="M106.717 81.754c0-.998.809-1.807 1.807-1.807h.562c.998 0 1.807.81 1.807 1.807v2.65c0 .998-.809 1.807-1.807 1.807h-.562c-.998 0-1.807-.81-1.807-1.807v-2.65zM119.245 81.754c0-.998.809-1.807 1.807-1.807h.91c.998 0 1.807.81 1.807 1.807v2.65c0 .998-.809 1.807-1.807 1.807h-.91c-.998 0-1.807-.81-1.807-1.807v-2.65z"
      />
      <path
        fill="url(#paint5_linear_10_830)"
        fillRule="evenodd"
        d="M146.483 137.151a4.673 4.673 0 01-.423-.073c-5.114-1.121-7.447-10.234-5.21-20.355 2.236-10.121 8.195-17.417 13.31-16.297.066.015.132.031.197.048l35.296 7.705-8.435 36.578-34.735-7.606z"
        clipRule="evenodd"
      />
      <path
        fill="url(#paint6_linear_10_830)"
        d="M194.323 128.554c-2.233 10.15-8.185 17.467-13.293 16.343-5.108-1.124-7.438-10.263-5.204-20.414 2.234-10.15 8.185-17.467 13.293-16.343 5.108 1.124 7.438 10.263 5.204 20.414z"
      />
      <path
        fill="url(#paint7_linear_10_830)"
        d="M185.931 122.188l-9.82 7.97 2.207 13.21 9.599-10.044-1.986-11.136z"
      />
      <path
        fill="url(#paint8_linear_10_830)"
        d="M239.368 102.706l-7.4-4.617c-.756-.472-1.76-.1-2.044.745-.772 2.29-2.276 6.41-3.932 9.086-2.377 3.839-3.938 6.054-7.566 8.742-4.248 3.146-7.403 3.912-12.573 5.01-5.437 1.155-15.856.332-18.742.072a1.254 1.254 0 00-1.187.562c-.612.962-1.676 2.871-1.808 4.697-.116 1.594.339 3.952.629 5.247.126.563.606.965 1.182 1.003 3.203.211 13.657.803 19.287-.067 7.048-1.089 11.431-1.696 17.368-5.65 4.876-3.248 6.854-6.162 10.336-10.874 2.776-3.759 5.781-9.81 6.952-12.253a1.33 1.33 0 00-.502-1.703z"
      />
      <path
        fill="url(#paint9_linear_10_830)"
        fillRule="evenodd"
        d="M235.476 107.985a.09.09 0 00-.033-.118l-8.173-5.109c-.05-.032-.116-.011-.133.046-.275.894-2.22 7.079-4.438 10.668-2.374 3.843-3.934 6.061-7.558 8.75-4.244 3.149-7.397 3.916-12.562 5.015-6.116 1.301-17.161-.601-17.947-.739a.083.083 0 00-.077.028c-.051.056-.158.175-.301.344a.097.097 0 00-.02.039 5.971 5.971 0 00-.079.435c-.236 1.667.307 3.972.668 5.246.164.578.67.979 1.267 1.027 2.783.225 10.901.763 16.375-.084l.465-.072c6.773-1.047 11.088-1.714 16.888-5.584 4.564-3.045 6.587-5.797 9.685-10.012l.641-.871c1.888-2.561 3.882-6.185 5.332-9.009z"
        clipRule="evenodd"
      />
      <path fill="#ADB2BE" d="M118.126 93.368a2.778 2.778 0 11-5.556 0 2.778 2.778 0 015.556 0z" />
      <path
        fill="#818C9E"
        fillRule="evenodd"
        d="M118.038 94.063a2.778 2.778 0 10-5.38 0 2.779 2.779 0 015.38 0z"
        clipRule="evenodd"
      />
      <path
        fill="url(#paint10_linear_10_830)"
        d="M175.253 132.511L140 124.271s.206 2.817.499 4.644c.272 1.697 1.263 4.582 2.221 5.939 1.044 1.48 2.674 2.099 2.674 2.099l34.537 7.457s-2.563-3.031-3.536-4.957c-1.363-2.698-1.142-6.942-1.142-6.942z"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10_830"
          x1="115.05"
          x2="115.05"
          y1="-342.657"
          y2="93.153"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C1C6CE" />
          <stop offset="1" stopColor="#C1C6CE" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10_830"
          x1="84.445"
          x2="146.438"
          y1="129.132"
          y2="42.113"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADB2BE" />
          <stop offset="1" stopColor="#ADB2BE" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10_830"
          x1="105.532"
          x2="83.89"
          y1="89.502"
          y2="122.907"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADB2BE" />
          <stop offset="0.469" stopColor="#ADB2BE" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_10_830"
          x1="133.072"
          x2="144.589"
          y1="107.384"
          y2="109.623"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.323" stopColor="#818C9D" />
          <stop offset="1" stopColor="#818C9D" stopOpacity="0.4" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_10_830"
          x1="129.446"
          x2="140.963"
          y1="122.1"
          y2="124.339"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.323" stopColor="#818C9D" />
          <stop offset="1" stopColor="#818C9D" stopOpacity="0.4" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_10_830"
          x1="169.259"
          x2="162.481"
          y1="105.095"
          y2="140.192"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C7CBD2" />
          <stop offset="1" stopColor="#A4ABB6" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_10_830"
          x1="190.123"
          x2="176.534"
          y1="108.45"
          y2="143.036"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#818C9D" />
          <stop offset="1" stopColor="#A5ACB7" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_10_830"
          x1="187.917"
          x2="175.208"
          y1="128.622"
          y2="137.152"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#818C9D" />
          <stop offset="1" stopColor="#A5ACB7" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_10_830"
          x1="184.009"
          x2="230.045"
          y1="128.282"
          y2="113.583"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D3D7DC" />
          <stop offset="0.453" stopColor="#D3D7DC" />
          <stop offset="1" stopColor="#D3D7DC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_10_830"
          x1="181.438"
          x2="221.985"
          y1="132.468"
          y2="121.847"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BFC4CC" />
          <stop offset="0.729" stopColor="#BFC4CC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_10_830"
          x1="229.787"
          x2="138.582"
          y1="171.202"
          y2="130.225"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#818C9D" />
          <stop offset="1" stopColor="#A5ACB7" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default APIFailureImage
